import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  RadioGroup,
  MultiAutocomplete,
} from '~/components/Form';
import { t } from '~/helpers';

function RelTrocaBateriaDbic() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [bico, setBico] = useState(0);

  const [valuePosto, setValuePosto] = React.useState([]);
  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;

    return {
      ...params,
      idposto: idPosto,
      idbico: idBico,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.trocabateriadbic')}
      relatorio="reltrocabateriadbic"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      {/* <span>POSTO</span>
      <div>{`valuePosto: ${valuePosto !== null ? `'${valuePosto}'` : 'null'}`}</div>
      <div>{`inputValuePosto: '${inputValuePosto}'`}</div>

      <span>BICO</span>
      <div>{`valueBico: ${valueBico !== null ? `'${valueBico}'` : 'null'}`}</div>
      <div>{`inputValueBico: '${inputValueBico}'`}</div> */}

      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          setValueBico(0);
          setInputValueBico('');
          if (value[0]?.idposto !== null) {
            setPosto(value);
            setValuePosto(value);
          } else {
            setPosto([]);
            setValuePosto([]);
          }
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        // defaultValue=""
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        getValue={(value) => {
          setValueBico(value.idbico);
        }}
        params={{
          wherefield: 'idposto',
          valuewherefield: valuePosto[0]?.idposto,
          typewherefield: 'EQUALS',
          fieldlist: 'idbico, bicoprodutobico',
        }}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelTrocaBateriaDbic;
